import { render, staticRenderFns } from "./ResetPasswordPopup.vue?vue&type=template&id=0f343a1e&scoped=true"
import script from "./ResetPasswordPopup.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPopup.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordPopup.vue?vue&type=style&index=0&id=0f343a1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f343a1e",
  null
  
)

export default component.exports